var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.99V15M12 9V10.9967V9Z",
    stroke: "#4F46E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00781 20H19.0133C19.3397 19.9977 19.6606 19.9158 19.948 19.7613C20.2354 19.6069 20.4806 19.3847 20.6621 19.114C20.8436 18.8433 20.956 18.5325 20.9895 18.2085C21.0229 17.8845 20.9764 17.5573 20.854 17.2554L13.7512 5.02971C13.5782 4.71773 13.3245 4.45768 13.0167 4.27659C12.7088 4.09551 12.3579 4 12.0005 4C11.6431 4 11.2923 4.09551 10.9844 4.27659C10.6765 4.45768 10.4229 4.71773 10.2498 5.02971L3.14708 17.2554C3.02698 17.5504 2.97935 17.8698 3.00818 18.1869C3.03701 18.504 3.14145 18.8096 3.3128 19.0782C3.48414 19.3469 3.71742 19.5707 3.99314 19.731C4.26886 19.8914 4.57904 19.9836 4.89776 20",
    stroke: "#4F46E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.b635035da122c354a3fb684c71de522d.svg";
export { ForwardRef as ReactComponent };